<template>
  <div>
    <My-new-nav ref="header" menuTheme="white"></My-new-nav>
    <div class="news">
      <div class="banner">
        <img src="../../../assets/image/Mobile/news/news_industry.png" alt="" />
        <p>在这里，您可以了解到医疗行业最新的新闻资讯</p>
      </div>
      <div class="content">
        <p class="title">医疗行业动态</p>
        <div class="item" v-for="(item, index) in news" :key="index" @click="onItemClick(item.id)">
          <img class="item-left" :src="item.imgUrl" alt="" />
          <div class="item-right">
            <div class="desc">{{ item.title }}</div>
            <div class="time">{{ item.createTime }}</div>
          </div>
        </div>
      </div>
      <div class="btn">
        <LoadMoreButton v-if="isMore" @loadMore="loadMore" />
      </div>
    </div>
  </div>
</template>
<script>
import { selectNewList } from "../../../../common/api";
import {
  hiddenLoading,
  showLoading,
  showToast,
} from "../../../../common/toast";
import LoadMoreButton from "@/components/mobileMoreButton/index.vue";

export default {
  components: { LoadMoreButton },
  data() {
    return {
      pageIndex: 1,
      pageSize: 20,
      scrollTop: 0,
      isMore: false,
      news: [],
    };
  },
  activated() {
    this.reset();
    this.getNews();
  },
  methods: {
    getNews() {
      let data = {
        pageNum: this.pageIndex,
        pageSize: this.pageSize,
        isOfficial: 1,
        visitSourceType: 'mobile', // mobile(移动端)   pc(pc端)
        newsType: 'industry'
      };
      showLoading();
      let count = this.pageSize * this.pageIndex;
      selectNewList(data)
        .then((res) => {
          hiddenLoading();
          if (res.responseCode === 0) {
            this.news = this.news.concat(res.responseBody);
            this.isMore = res.count > count;
          } else {
            showToast(res.responseMsg);
          }
        })
        .catch((e) => {
          console.log(e);
          showToast(e);
        })
    },
    loadMore() {
      this.pageIndex = ++this.pageIndex;
      this.getNews();
    },
    onItemClick(id) {
      this.routerJump("/news/detail_mobile", id);
    },
    routerJump(m, id) {
      let header = document.getElementById("app");
      header.scrollTop = 0;
      this.$store.commit("changeActiveMenu", m);
      window.scrollTo(0, 0);
      this.$router.push({ path: m + "/" + id });
    },
    reset() {
      this.pageIndex = 1;
      this.pageSize = 20;
      this.scrollTop = 0;
      this.isMore = false;
      this.news = [];
    }
  },
};
</script>

<style scoped lang="scss">
.banner {
  background-image: url("../../../assets/image/Mobile/news/banner_industry.png");
  background-repeat: no-repeat;
  width: 100%;
  height: 520px;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.banner img {
  margin-left: 36px;
  width: 460px;
  height: 62px;
}

.banner p {
  margin-top: 30px;
  display: inline;
  margin-left: 36px;
  font-size: 30px;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 8px;
}

.content {
  margin: 0 36px;
  padding-bottom: 40px;
  min-height: 800px;

  .title {
    font-size: 54px;
    font-weight: bold;
    color: #333333;
    line-height: 54px;
    letter-spacing: 3px;
    margin-top: 80px;
  }

  .item {
    margin-top: 40px;
    display: flex;
    height: 240px;

    .item-left {
      height: 220px;
      width: 40%;
      background-color: #cccccc;
      object-fit: cover;
    }

    .item-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      justify-content: space-between;

      .desc {
        font-size: 42px;
        font-weight: 400;
        color: #212121;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }

      .time {
        height: 60px;
        line-height: 60px;
        color: #52647c;
        font-size: 36px;
      }
    }
  }
}

.btn {
  margin: 80px 36px 64px 36px;
}
</style>
